import { coreProductClassification } from "@tc/drizzle-v2"
import { DbTransaction } from "@tc/middy-decorators"
import { and, eq, inArray } from "drizzle-orm"

/**
 * Fetch NZHSCode values from classification table for given product IDs.
 * Returns a map of productId → { id, name } for enriching product attributes.
 */
export const fetchNzhscFromClassification = async (
  tx: DbTransaction,
  productIds: string[],
): Promise<Map<string, { id: string | null; name: string | null }>> => {
  const result = new Map<string, { id: string | null; name: string | null }>()
  if (productIds.length === 0) return result

  const BATCH_SIZE = 2000
  const classifications: Array<{ productItemId: string | null; itemCode: string | null; value: string | null }> = []
  for (let i = 0; i < productIds.length; i += BATCH_SIZE) {
    const batch = productIds.slice(i, i + BATCH_SIZE)
    const batchRows = await tx
      .select({
        productItemId: coreProductClassification.productItemId,
        itemCode: coreProductClassification.itemCode,
        value: coreProductClassification.value,
      })
      .from(coreProductClassification)
      .where(
        and(
          inArray(coreProductClassification.productItemId, batch),
          eq(coreProductClassification.fieldUniqueId, "_prod_NZHSC"),
        ),
      )
    classifications.push(...batchRows)
  }

  for (const c of classifications) {
    if (c.productItemId) {
      result.set(c.productItemId, {
        id: c.itemCode ?? c.value ?? null,
        name: c.value ?? c.itemCode ?? null,
      })
    }
  }

  return result
}
